<template lang='pug'>
  div
    div
      //
        Recreate Oops
        :showModal="conduitClientError === null && greenskyUnderReview && !showFan"
      StatusModal(v-if='greenskyUnderReview && !showFan' :companyImage='greenskySvg' :mainButtonFunction='checkStatus' :secondaryButtonFunction='!easyLinkUser ? returnHome : null' :showModal='greenskyUnderReview && !showFan')
        div(slot='main-text')
          p.mb-2
            strong Application Id:
            |             {{ applicationId }}
          p.mb-2
            strong Applicant:
            |             {{ customerName }}
          p.mb-2
            strong Requested Amount:
            |             {{ loanAmount }}
        div(slot='secondary-text')
          // Display different messaging depending on the reason an application is still under review
          p(v-if="applicationPendingDescription==='Frozen Credit'")
            | Your application is under review, but it seems there is a freeze on your credit. Please, call GreenSky directly to complete the application:
          p(v-else-if="applicationPendingDescription==='Locked'")
            | Your application is under review, but it seems there is a lock placed on your credit report. Please, call GreenSky directly to complete the application:
          p(v-else-if="applicationPendingDescription==='Consumer Statement'")
            | Your application is under review. A GreenSky representative will call you shortly. If you&apos;d like to contact GreenSky directly, please call:
          p(v-else-if="applicationPendingType==='POI'")
            | Your application has been approved pending verification of your income. Please, call GreenSky directly to complete the application:
          p.mb-4(v-else)
            | Your Application is currently under review.
            | Please, call GreenSky directly to complete the
            | application:
          PhoneLink(:phoneNumber="'866-936-0602'")
        div(v-if="applicationPendingDescription==='Consumer Statement'" slot='tertiary-text')
          | Once you've spoken to a GreenSky representative, check your application status by clicking below:
        div(v-else='' slot='tertiary-text')
          | Then, come back to check the status by clicking below
        span(slot='main-button-text')
          | Get Status
        div(slot='warning-text')
          p.mt-2(style='font-weight: 900;')
            | Please do not close this page before calling
            | and getting your status.
            | Otherwise, your progress will be lost.
        span(slot='secondary-button-text' v-if='!easyLinkUser')
          | Return Home
      StatusModal(v-else-if='hasError && !showFan' :mainButtonFunction='returnHome' :showModal='hasError && !showFan')
        .mx-4(slot='main-text')
          p
            img(:src='desertPng' height='150')
          p.display-1.mb-4
            | Oops!
          p.subheading.mb-4(v-if="_has(conduitClientError, 'response.data.errors') && conduitClientError.response.data.errors.length > 0")
            | {{ conduitClientError.response.data.errors[0].detail }}
          p.title.mb-4(v-else)
            | We&apos;re having some trouble processing your application at this time
          // <p> {{conduitClientError }} </p>
          p.subheading
            | Please contact your contractor or try again
        span(slot='main-button-text')
          | OK
      StatusModal(v-else-if='conduitClientError === null && declined && has2ndLook && !showFan && !show2ndLook' :companyImage='greenskySvg' :mainButtonFunction='switchModals' :showModal='conduitClientError === null && declined && has2ndLook && !showFan')
        div(slot='main-text')
          p.mb-2
            strong Application Id:
            |             {{ applicationId }}
          p.mb-2
            strong Applicant:
            |             {{ customerName }}
          p.mb-2
            strong Requested Amount:
            |             {{ loanAmount }}
        span(slot='secondary-text')
          p.mb-4
            | We are unable to approve your application. You
            | will receive a letter within 30 days with the
            | results of the credit review. You can call
            | GreenSky directly for more information:
            br
          PhoneLink(:phoneNumber="'866-936-0602'")
        span(slot='main-button-text')
          | See Other Offers
      StatusModal(v-else-if='declined && !has2ndLook && !showFan' :companyImage='greenskySvg' :mainButtonFunction='returnHome' :showModal='declined && !has2ndLook && !showFan')
        div(slot='main-text')
          | Sorry, no offers available.
        div(slot='secondary-text')
          p.mb-4
            | We are unable to approve your application. You
            | will receive a letter within 30 days with the
            | results of the credit review. You can call
            | GreenSky directly for more information:
            br
          PhoneLink(:phoneNumber="'866-936-0602'")
        span(slot='main-button-text')
          | OK
      StatusModal(v-else-if='show2ndLook && !showFan' :companyImage='fortivaSvg' :mainButtonFunction='beginSecondLook' :secondaryButtonFunction='returnHome' :showModal='show2ndLook && !showFan')
        div(slot='main-text')
          p.mb-4
            | We are happy to proceed with the application for a Fortiva
            | Retail Credit payment option. Their program allows you to
            | make monthly payments to cover the cost of the job with no
            | down payment required. Please click to continue.
          p.mb-4
            | Submitting the application will not affect your credit score.
        span(slot='main-button-text')
          | Proceed
        span(slot='secondary-button-text')
          | Not Interested
</template>

<script>
  import PhoneLink from 'Components/PhoneLink.vue'
  import StatusModal from 'Components/StatusModal.vue'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { fortiva } from 'Helpers/lenders.js'
  import _has from 'lodash/has'

  export default {
    name: 'ApplicationStatusGreenskyFlow',
    components: {
      PhoneLink,
      StatusModal
    },
    data () {
      return {
        desertPng: require('Assets/empty-desert.png'),
        greenskySvg: require('Assets/greensky_logo.svg'),
        fortivaSvg: require('Assets/fortiva_logo.svg'),
        show2ndLook: false,
        fortiva,
        inspiration: require('Assets/Inspiration.png'),
      }
    },
    props: {
      showFan: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        applicationStatus: state => state.loanApplication.applicationStatus,
        applicationPendingType: state=>state.loanApplication.applicationPendingType,
        applicationPendingDescription: state=> state.loanApplication.applicationPendingDescription,
        applicationId: state => state.loanApplication.applicationId,
        conduitClientError: state => state.loanApplication.conduitClientError,
        customerData: state => state.loanApplication.customerData,
        loanAmount: state => state.loanApplication.loanAmount,
        lender: state => state.loanApplication.lender,
        dealerName: state => state.user.companyName,
        dealerEmail: state => state.user.email,
        easyLinkUser: state => state.easyLink.active,
      }),
      ...mapGetters(['has2ndLook']),
      customerName () {
        return this.customerData.firstName + ' ' + this.customerData.lastName
      },
      declined() {
        return this.applicationStatus === 'declined'
      },
      greenskyDeclinedModal () {
        return this.applicationStatus === 'declined' &&
          this.lender.id === 'greensky' &&
          !this.show2ndLook

        // recreate oops
        // return true
      },
      greenskyUnderReview () {
        return this.applicationStatus === 'under_review' &&
          this.lender.id === 'greensky'
      },
      hasError () {
        return this.applicationStatus === 'error' || this.conduitClientError !== null
      },
    },
    methods: {
      _has,
      ...mapActions([
        'setLender',
        'singleStatusCheck'
      ]),
      beginSecondLook () {
        this.$emit('unmounted')
        this.setLender(fortiva)
        this.$router.push({
          path: '/credit-application/submit-application'
        })
      },
      checkStatus () {
        this.$emit('showFan')
        this.singleStatusCheck()
      },
      redirectToSite() {
        window.location = 'https://www.creditforcomfort.com/'
      },
      returnHome () {
        this.$emit('returnHome')
      },
      switchModals () {
        this.show2ndLook = true
      }
    }
  }
</script>
